import { render } from "./SingleRoomModal.vue?vue&type=template&id=2bf6dae8&scoped=true&ts=true"
import script from "./SingleRoomModal.vue?vue&type=script&lang=ts"
export * from "./SingleRoomModal.vue?vue&type=script&lang=ts"

import "./SingleRoomModal.vue?vue&type=style&index=0&id=2bf6dae8&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf6dae8"]])

export default __exports__